import FormGroup from '../FormGroup'

// eslint-disable-next-line react/forbid-foreign-prop-types
const propTypes = { ...FormGroup.propTypes }
delete propTypes.children

export default propTypes
